export function hideExtraSectionIfOdd() {
    // Get all `section` elements in the document
    const allSections = document.querySelectorAll(".wp-site-blocks section");
    const extraSection = document.querySelector("footer .extra-footer-section");
    const footer = document.querySelector("footer");


    // Get the very last `section` element
    const lastSection = allSections[allSections.length - 1];

    if (lastSection) {
        const lastSectionStyle = window.getComputedStyle(lastSection, ":before");

        // Check if the last section has a ::before pseudo-element
        if (lastSectionStyle && lastSectionStyle.content !== "none" && extraSection) {
            extraSection.style.display = ""; // Restore default display
        } else if (extraSection) {
            extraSection.style.display = "none";

            footer.classList.add("extra-section-hidden");
        }
    }

    if (document.querySelector('.archive-pagination')) {
        const footerArchive = document.querySelector('.post-type-archive-book footer .extra-footer-section');
        if (footerArchive) {
            footerArchive.style.display = 'none';
            footer.classList.add("extra-section-hidden");
        }
    }
}


